import { useCallback, useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'

import http from '../../../../../../shared/http'
import { notifyError } from '../../../../../../shared/errorMessage'
import { TApi } from '../../../../../../shared/const'

import Loading from '../../../../../../UI/Loading'

import SettingHint from '../SettingHint'

/*
 * Die Liste und die Detailansicht liegen weiterhin im Ordner Communication:
 * Sie teilen sich den Zielgruppenfilter und das Stilmodul mit den
 * Vorlagenlisten. Ein zweiter Satz Karten-Stile nur für diesen Reiter wäre die
 * teurere Lösung gewesen.
 */
import DocumentList from '../../../Communication/DocumentList'
import DocumentDetail from '../../../Communication/DocumentDetail'

import styles from '../style.module.scss'

// Tiefer Link aus dem Handbuch: /settings?item=<key>#documentTemplates öffnet
// den Reiter und darin gleich die Vorschau der genannten Vorlage.
const initialItem = () => {
	if (typeof window === 'undefined') return null
	return new URLSearchParams(window.location.search).get('item') || null
}

/**
 * Dokumentvorlagen (PDF/Urkunden).
 *
 * Reine Nachschau: Pro Vorlage lassen sich bis zu zehn echte Datensätze
 * durchblättern und die aktuelle Vorlage live als PDF rendern. Bearbeiten
 * lässt sich hier nichts — die Vorlagen stehen im Code.
 */
export default function DocumentTemplates() {
	const { t } = useTranslation()

	const [list, setList] = useState(null)
	const [selectedKey, setSelectedKey] = useState(initialItem)

	const fetchList = useCallback(async () => {
		try {
			// `disableToast`: Der eigene Satz benennt, was nicht geladen werden konnte.
			const { data } = await http.get(TApi.ADMIN_COMM_DOCUMENTS, { disableToast: true })
			setList(data)
		} catch (error) {
			notifyError(error, 'Communication templates could not be loaded')
			setList([])
		}
		// t bewusst NICHT in den Abhängigkeiten: useTranslation liefert bei jedem
		// Render eine neue Funktionsreferenz, das ergäbe die Schleife
		// Render → Laden → Render.
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [])

	useEffect(() => {
		fetchList()
	}, [fetchList])

	return (
		<div id="documentTemplates" className={styles.root}>
			<section className={styles.section}>
				<h3 className={styles.sectionTitle}>{t('Document templates')}</h3>
				<SettingHint
					example={t(
						'Example: the participation certificate — pick a real company, look at the PDF, download it if needed.'
					)}
				>
					{t(
						'All PDF documents the application generates: certificates, invoices, confirmations. Each template can be viewed with real data — up to ten records to leaf through. The templates themselves are part of the application and cannot be edited here.'
					)}
				</SettingHint>
				<div className={styles.sectionContent}>
					{list === null ? (
						<Loading />
					) : selectedKey ? (
						<DocumentDetail
							key={selectedKey}
							items={list}
							documentKey={selectedKey}
							onBack={() => setSelectedKey(null)}
						/>
					) : (
						<DocumentList items={list} onOpen={setSelectedKey} />
					)}
				</div>
			</section>
		</div>
	)
}
